export default function Container(theme) {
    return {
        MuiContainer: {
            styleOverrides: {
                maxWidthXxl: {
                    padding: {sm:"10px",md:"23px 48px !important"},
                },
            }
        },
    };
}
